import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
// import { Layout, SeekerLayout, EmployerLayout, OrgLayout, TutorialLayout } from '@/layout/index.js'
// import { Layout, SeekerLayout, EmployerLayout, OrgLayout, ResumeLayout, AdminLayout } from '@/layout/index.js'
import { Layout } from '@/layout/index.js'

Vue.use(Router)

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/moving/index'),
        name: 'index',
        meta: { title: 'Index', icon: 'dashboard', affix: true }
      },
      {
        path: 'home.html',
        component: () => import('@/views/moving/HomeMoving'),
        name: 'home-moving',
        meta: { title: '家居搬運服務', icon: 'dashboard', affix: true }
      },
      {
        path: 'office.html',
        component: () => import('@/views/moving/OfficeMoving'),
        name: 'office-moving',
        meta: { title: '辦公室搬運服務', icon: 'dashboard', affix: true }
      },
      {
        path: 'home',
        component: () => import('@/views/moving/HomeMoving'),
        name: 'home-moving',
        meta: { title: '家居搬運服務', icon: 'dashboard', affix: true }
      },
      {
        path: 'office',
        component: () => import('@/views/moving/OfficeMoving'),
        name: 'office-moving',
        meta: { title: '辦公室搬運服務', icon: 'dashboard', affix: true }
      }
      // {
      //   path: 'home-moving-editor',
      //   component: () => import('@/views/moving/HomeMoving'),
      //   name: 'home-moving',
      //   meta: { title: '家居搬運服務', icon: 'dashboard', affix: true },
      //   props: { debug: true }
      // },
      // {
      //   path: 'office-moving-editor',
      //   component: () => import('@/views/moving/OfficeMoving'),
      //   name: 'office-moving',
      //   meta: { title: '辦公室搬運服務', icon: 'dashboard', affix: true },
      //   props: { debug: true }
      // }
    ]
  }
  // {
  //   path: '/order/checkout',
  //   component: () => import('@/views/order/checkout')
  // },
  // {
  //   path: '/payment/success',
  //   component: () => import('@/views/payment/success'),
  //   hidden: true
  // },
  // {
  //   path: '/payment/fail',
  //   component: () => import('@/views/payment/fail'),
  //   hidden: true
  // },
  // {
  //   path: '/404',
  //   component: () => import('@/views/error-page/404'),
  //   hidden: true
  // },
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path(.*)',
  //       component: () => import('@/views/redirect/index')
  //     }
  //   ]
  // },
  // {
  //   path: '/register',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/Register'),
  //       name: 'register',
  //       meta: { title: 'Register', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/login',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/Login'),
  //       name: 'login',
  //       meta: { title: 'Login', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/logout',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/Logout'),
  //       name: 'logout',
  //       meta: { title: 'Logout', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/employer-register',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/EmployerRegister'),
  //       name: 'employer-register',
  //       meta: { title: 'Employer Register', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/org-register',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/OrgRegister'),
  //       name: 'org-register',
  //       meta: { title: 'Organization Register', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/forget',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/Forget'),
  //       name: 'forget',
  //       meta: { title: 'Forget Password', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/forget-confirm',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/ForgetConfirm'),
  //       name: 'forgetConfirm',
  //       meta: { title: 'Reset Password', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/employer-login',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/EmployerLogin'),
  //       name: 'employer-login',
  //       meta: { title: 'Employer Login', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/resume',
  //   component: ResumeLayout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/resume/index'),
  //       name: 'resume',
  //       meta: { title: 'Resume', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/resume-dev',
  //   component: ResumeLayout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/resume/development'),
  //       name: 'resumedev',
  //       meta: { title: 'Resume Dev', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/about',
  //   children: [
  //     {
  //       path: 'about',
  //       component: () => import('@/views/about/index'),
  //       name: 'about',
  //       meta: { title: 'About', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/login/OrgLogin'),
  //       name: 'org-login',
  //       meta: { title: 'Organization Login', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },

  // {
  //   path: '/admin',
  //   component: AdminLayout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'company',
  //       component: () => import('@/views/admin/company'),
  //       name: 'company',
  //       meta: { title: 'Company', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'jobfair',
  //       component: () => import('@/views/admin/jobfair'),
  //       name: 'jobfair',
  //       meta: { title: 'Job Fair', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/org',
  //   component: OrgLayout,
  //   redirect: '/',
  //   children: [
  //     // {
  //     //   path: '',
  //     //   component: () => import('@/views/org/index'),
  //     //   name: 'org-home',
  //     //   meta: { title: 'Job Search', icon: 'dashboard', affix: true }
  //     // },
  //     {
  //       path: 'management',
  //       component: () => import('@/views/org/management'),
  //       name: 'management',
  //       meta: { title: 'Management', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'org-profile',
  //       component: () => import('@/views/org/profile'),
  //       name: 'org-profile',
  //       meta: { title: 'profile', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/employer',
  //   component: EmployerLayout,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/employer/index'),
  //       name: 'employer',
  //       meta: { title: 'Employer', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'job-ads',
  //       component: () => import('@/views/employer/JobAds'),
  //       name: 'job-ads',
  //       meta: { title: 'Job Ads', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'candidate',
  //       component: () => import('@/views/employer/Candidate'),
  //       name: 'candidate',
  //       meta: { title: 'Candidate', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'talent',
  //       component: () => import('@/views/employer/Talent'),
  //       name: 'talent',
  //       meta: { title: 'Talent', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'purchase',
  //       component: () => import('@/views/employer/Purchase'),
  //       name: 'purchase',
  //       meta: { title: 'Purchase', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'billing',
  //       component: () => import('@/views/employer/Billing'),
  //       name: 'billing',
  //       meta: { title: 'Billing', icon: 'dashboard', affix: true }
  //     },
  //     {
  //       path: 'settings',
  //       component: () => import('@/views/employer/Settings'),
  //       name: 'settings',
  //       meta: { title: 'Settings', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/seeker',
  //   component: SeekerLayout,
  //   children: [
  //     // {
  //     //   path: '',
  //     //   component: () => import('@/views/seeker/index'),
  //     //   name: 'home',
  //     //   meta: { title: 'Job Search', icon: 'dashboard', affix: true }
  //     // },
  //     {
  //       path: 'playground',
  //       component: () => import('@/views/playground/index'),
  //       name: 'playground',
  //       meta: { title: 'Playground', icon: 'dashboard', affix: true }
  //     }
  //     // {
  //     //   path: 'job-search',
  //     //   component: () => import('@/views/seeker/index'),
  //     //   name: 'job-search',
  //     //   meta: { title: 'Job Search', icon: 'dashboard', affix: true }
  //     // }, {
  //     //   path: 'profile',
  //     //   component: () => import('@/views/seeker/Profile'),
  //     //   name: 'profile',
  //     //   meta: { title: 'Profile', icon: 'dashboard', affix: true }
  //     // }
  //   ]
  // }
  // {
  //   path: '/management-user',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/management-user/list'),
  //       name: 'ManagementUser',
  //       meta: { title: 'Management User', icon: 'list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/black-list',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/black-list/list'),
  //       name: 'black-list',
  //       meta: { title: 'BlackList', icon: 'list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/organization',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/organization/list'),
  //       name: 'Organization',
  //       meta: { title: 'Organization', icon: 'list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/user',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/user/list'),
  //       name: 'User',
  //       meta: { title: 'Api User', icon: 'list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/log',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/log/list'),
  //       name: 'log',
  //       meta: { title: 'Log', icon: 'list' }
  //     }
  //   ]
  // }
  // {
  //   path: '/Organization',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/OrganizationService/list'),
  //       name: 'Organization',
  //       meta: { title: 'Organization', icon: 'list' },
  //     },
  //   ],
  // },
  // {
  //   path: '/Log',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/LogService/list'),
  //       name: 'Log',
  //       meta: { title: 'Log', icon: 'list' },
  //     },
  //   ],
  // },
  // {
  //   path: '/User',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/api-server/UserService/list'),
  //       name: 'User',
  //       meta: { title: 'User', icon: 'list' },
  //     },
  //   ],
  // },
  // {

  //   path: '/documentation',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/documentation/index'),
  //       name: 'Documentation',
  //       meta: { title: 'Documentation', icon: 'documentation', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/guide',
  //   component: Layout,
  //   redirect: '/guide/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/guide/index'),
  //       name: 'Guide',
  //       meta: { title: 'Guide', icon: 'guide', noCache: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/profile',
  //   component: Layout,
  //   redirect: '/profile/index',
  //   hidden: true,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/profile/index'),
  //       name: 'Profile',
  //       meta: { title: 'Profile', icon: 'user', noCache: true }
  //     }
  //   ]
  // }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: '/permission',
  //   component: Layout,
  //   redirect: '/permission/page',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'Permission',
  //   meta: {
  //     title: 'Permission',
  //     icon: 'lock',
  //     roles: ['admin', 'editor'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'page',
  //       component: () => import('@/views/permission/page'),
  //       name: 'PagePermission',
  //       meta: {
  //         title: 'Page Permission',
  //         roles: ['admin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'directive',
  //       component: () => import('@/views/permission/directive'),
  //       name: 'DirectivePermission',
  //       meta: {
  //         title: 'Directive Permission'
  //         // if do not set roles, means: this page does not require permission
  //       }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/permission/role'),
  //       name: 'RolePermission',
  //       meta: {
  //         title: 'Role Permission',
  //         roles: ['admin']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/icon',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/icons/index'),
  //       name: 'Icons',
  //       meta: { title: 'Icons', icon: 'icon', noCache: true }
  //     }
  //   ]
  // },
  // /** when your routing map is too long, you can split it into small modules **/
  // componentsRouter,
  // chartsRouter,
  // nestedRouter,
  // tableRouter,
  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/list',
  //   name: 'Example',
  //   meta: {
  //     title: 'Example',
  //     icon: 'el-icon-s-help'
  //   },
  //   children: [
  //     {
  //       path: 'create',
  //       component: () => import('@/views/example/create'),
  //       name: 'CreateArticle',
  //       meta: { title: 'Create Article', icon: 'edit' }
  //     },
  //     {
  //       path: 'edit/:id(\\d+)',
  //       component: () => import('@/views/example/edit'),
  //       name: 'EditArticle',
  //       meta: { title: 'Edit Article', noCache: true, activeMenu: '/example/list' },
  //       hidden: true
  //     },
  //     {
  //       path: 'list',
  //       component: () => import('@/views/example/list'),
  //       name: 'ArticleList',
  //       meta: { title: 'Article List', icon: 'list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/tab',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/tab/index'),
  //       name: 'Tab',
  //       meta: { title: 'Tab', icon: 'tab' }
  //     }
  //   ]
  // },
  // {
  //   path: '/error',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'ErrorPages',
  //   meta: {
  //     title: 'Error Pages',
  //     icon: '404'
  //   },
  //   children: [
  //     {
  //       path: '401',
  //       component: () => import('@/views/error-page/401'),
  //       name: 'Page401',
  //       meta: { title: '401', noCache: true }
  //     },
  //     {
  //       path: '404',
  //       component: () => import('@/views/error-page/404'),
  //       name: 'Page404',
  //       meta: { title: '404', noCache: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/error-log',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'log',
  //       component: () => import('@/views/error-log/index'),
  //       name: 'ErrorLog',
  //       meta: { title: 'Error Log', icon: 'bug' }
  //     }
  //   ]
  // },
  // {
  //   path: '/excel',
  //   component: Layout,
  //   redirect: '/excel/export-excel',
  //   name: 'Excel',
  //   meta: {
  //     title: 'Excel',
  //     icon: 'excel'
  //   },
  //   children: [
  //     {
  //       path: 'export-excel',
  //       component: () => import('@/views/excel/export-excel'),
  //       name: 'ExportExcel',
  //       meta: { title: 'Export Excel' }
  //     },
  //     {
  //       path: 'export-selected-excel',
  //       component: () => import('@/views/excel/select-excel'),
  //       name: 'SelectExcel',
  //       meta: { title: 'Export Selected' }
  //     },
  //     {
  //       path: 'export-merge-header',
  //       component: () => import('@/views/excel/merge-header'),
  //       name: 'MergeHeader',
  //       meta: { title: 'Merge Header' }
  //     },
  //     {
  //       path: 'upload-excel',
  //       component: () => import('@/views/excel/upload-excel'),
  //       name: 'UploadExcel',
  //       meta: { title: 'Upload Excel' }
  //     }
  //   ]
  // },
  // {
  //   path: '/zip',
  //   component: Layout,
  //   redirect: '/zip/download',
  //   alwaysShow: true,
  //   name: 'Zip',
  //   meta: { title: 'Zip', icon: 'zip' },
  //   children: [
  //     {
  //       path: 'download',
  //       component: () => import('@/views/zip/index'),
  //       name: 'ExportZip',
  //       meta: { title: 'Export Zip' }
  //     }
  //   ]
  // },
  // {
  //   path: '/pdf',
  //   component: Layout,
  //   redirect: '/pdf/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/pdf/index'),
  //       name: 'PDF',
  //       meta: { title: 'PDF', icon: 'pdf' }
  //     }
  //   ]
  // },
  // {
  //   path: '/pdf/download',
  //   component: () => import('@/views/pdf/download'),
  //   hidden: true
  // },
  // {
  //   path: '/theme',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/theme/index'),
  //       name: 'Theme',
  //       meta: { title: 'Theme', icon: 'theme' }
  //     }
  //   ]
  // },
  // {
  //   path: '/clipboard',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/clipboard/index'),
  //       name: 'ClipboardDemo',
  //       meta: { title: 'Clipboard', icon: 'clipboard' }
  //     }
  //   ]
  // },
  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://github.com/PanJiaChen/vue-element-admin',
  //       meta: { title: 'External Link', icon: 'link' }
  //     }
  //   ]
  // },
  // // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
